module.exports = __webpack_public_path__ + "static/img/v60Bg-p.89b091b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v60Bg-p.png
// module id = P8Nt
// module chunks = 1